import { c as _c } from "react/compiler-runtime";
import type { GraphOperationUpdateSettings } from '@onefootprint/request-types/dashboard';
import type React from 'react';
import { useStore } from '@/components/playbook-builder';
import useEdit from '@/components/playbook-builder/hooks/use-edit';
import PlaybookGraphHeader from './playbook-graph-header';
export type HeaderSlots = {
  left?: React.ReactNode;
  right?: React.ReactNode;
  end?: React.ReactNode;
};
export type PlaybookGraphHeaderContainerProps = {
  slots?: HeaderSlots;
};
const PlaybookGraphHeaderContainer = t0 => {
  const $ = _c(7);
  const {
    slots
  } = t0;
  const editMutation = useEdit();
  const {
    data: t1
  } = useStore();
  const {
    settings,
    canEdit
  } = t1;
  let t2;
  if ($[0] !== editMutation) {
    t2 = async data => {
      await editMutation.mutateAsync({
        kind: "update_settings",
        ...data
      });
    };
    $[0] = editMutation;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const save = t2;
  let t3;
  if ($[2] !== canEdit || $[3] !== save || $[4] !== settings || $[5] !== slots) {
    t3 = <PlaybookGraphHeader slots={slots} settings={settings} canEdit={canEdit} onSave={save} />;
    $[2] = canEdit;
    $[3] = save;
    $[4] = settings;
    $[5] = slots;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default PlaybookGraphHeaderContainer;